__turbopack_context__.v({
  "contacts": "styles-module__0yyE0a__contacts",
  "info": "styles-module__0yyE0a__info",
  "socialIcon": "styles-module__0yyE0a__socialIcon",
  "title": "styles-module__0yyE0a__title",
});
